export default "__VITE_ASSET__BZTon7nB__"